<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "4rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><path fill-rule="evenodd" d="M8 39v-9h12v9H8zm12-19v8H8v-8h12zm0-12v10H8V8h12zm2-3H7a2 2 0 00-2 2v50a2 2 0 002 2h50a2 2 0 002-2V7a2 2 0 00-2-2H22zm20 3H22v31h20V8zm0 33H22v15h20V41zm2 15V41h12v15H44zm0-17v-9h12v9H44zm0-11h12v-9H44v9zm0-11h12V8H44v9zM20 56V41H8v15h12zm16-37h-8v8h8v-8zm-8-2a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2V19a2 2 0 00-2-2h-8z"/></svg>